export function createUnauthorizedHandler({ store, loginPathFragment = '/Users/login' }) {
  let isClearingClientState = false;

  return async (error) => {
    const status = error?.response?.status;
    const requestUrl = error?.config?.url || '';
    const isLoginRequest = requestUrl.includes(loginPathFragment);

    if (status === 401 && !isLoginRequest) {
      if (!isClearingClientState) {
        isClearingClientState = true;
        try {
          await store.dispatch('clearClientState');
        } finally {
          isClearingClientState = false;
        }
      }
    }

    return Promise.reject(error);
  };
}

export function registerAxiosAuthInterceptor(axiosInstance, unauthorizedHandler) {
  return axiosInstance.interceptors.response.use((response) => response, unauthorizedHandler);
}
